module.exports = __webpack_public_path__ + "b50df3fb841396412190948312d54900.svg";